import React, { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";

import Styles from "../../scss/orderSetting.module.scss";

export interface IOrderLimitsProps {
  start: string;
  end: string;
}

export interface IOrderInputProps {
  value: string | number | null;
  onChange: Function;
  disabled?: boolean;
}

export const OrderInput = ({ onChange, value, disabled }: IOrderInputProps) => {
  const { t } = useTranslation();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) =>
    onChange(e.target.value === "" ? "" : parseInt(e.target.value));
  return (
    <div className={Styles.orderInput}>
      <input
        disabled={disabled}
        value={Math.abs(parseInt(`${value}`, 10))}
        onChange={handleChange}
        type='number'
        min='0'
      />
      <span className={Styles.separator}></span>
      {t("misc.orders")}
    </div>
  );
};

export interface ITimeslotOrderProps {
  value: string | number | null;
  onChange: Function;
  start: string;
  end: string;
}

const TimeslotOrders = ({
  start,
  end,
  onChange,
  value,
}: ITimeslotOrderProps) => {
  return (
    <div className={value ? Styles.timeslotOrderSelected : Styles.timeslotOrder}>
      <span>{`${start} - ${end}`}</span>
      <OrderInput onChange={onChange} value={value} />
    </div>
  );
};

export default TimeslotOrders;
